import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import  Text  from './text.js';
import './Policy.css';

class PolicyForm extends Component {
  state = {
    redirect: false
  }
  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/yantra' />
    }
  }
  
  render() {
    return (
      <div className="form-div about">
        <Text />
      </div>
    )
  }
}

export default PolicyForm;



// WEBPACK FOOTER //
// ./src/components/Policy/PolicyForm.js